import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress'

const Container = styled.div`
    display : flex;
    align-items :center;
    justify-content:center;
`;



function CenteredLoadingIndicator(props) {
    const {width,height} = props.contentSize;
    
    return (
        <Container style={{width,height:height - 200}}>
            <CircularProgress/>
        </Container>
    )
}

CenteredLoadingIndicator.propTypes = {

}


const mapStateToProps = (state) => {
    return { 
        contentSize: state.app.contentSize 
    };
};

export default connect(mapStateToProps, { })(CenteredLoadingIndicator);